export default __webpack_public_path__ + "static/media/news-single.7ffd7d9e.jpg";